export default __webpack_public_path__ + "static/media/md.84cf3d94.svg";